/* Moida Maroc · comportements du thème (Pharos Systems, 2026). Sans bibliothèque. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ordinateur = window.matchMedia('(min-width: 1024px)');
  const moinsDanimations = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Bandeau du haut : messages qui se suivent ---------- */
  $$('[data-mo-annonce]').forEach((b) => {
    const m = $$('.mo-annonce__message', b);
    if (m.length < 2) return;
    let i = 0;
    setInterval(() => {
      m[i].classList.remove('est-visible');
      i = (i + 1) % m.length;
      m[i].classList.add('est-visible');
    }, (Number(b.dataset.duree) || 5) * 1000);
  });

  /* ---------- Grand menu ---------- */
  const entete = $('[data-mo-entete]');
  if (entete) {
    const items = $$('[data-mo-nav-item]', entete).filter((li) => $('[data-mo-mega]', li));
    let minuteur;
    const fermerTout = () => {
      entete.classList.remove('mega-direct');
      items.forEach((li) => { li.classList.remove('est-ouvert'); $('[data-mo-mega-bouton]', li)?.setAttribute('aria-expanded', 'false'); });
      entete.classList.remove('mega-ouvert');
    };
    const ouvrir = (li) => {
      entete.classList.toggle('mega-direct', items.some((x) => x !== li && x.classList.contains('est-ouvert')));
      items.forEach((x) => { if (x !== li) { x.classList.remove('est-ouvert'); $('[data-mo-mega-bouton]', x)?.setAttribute('aria-expanded', 'false'); } });
      li.classList.add('est-ouvert');
      $('[data-mo-mega-bouton]', li)?.setAttribute('aria-expanded', 'true');
      entete.classList.add('mega-ouvert');
    };
    items.forEach((li) => {
      li.addEventListener('mouseenter', () => { if (!ordinateur.matches) return; clearTimeout(minuteur); minuteur = setTimeout(() => ouvrir(li), 80); });
      li.addEventListener('mouseleave', () => { clearTimeout(minuteur); minuteur = setTimeout(fermerTout, 120); });
      $('[data-mo-mega-bouton]', li)?.addEventListener('click', () => (li.classList.contains('est-ouvert') ? fermerTout() : ouvrir(li)));
    });
    $$('[data-mo-nav-item]', entete).forEach((li) => {
      if (!$('[data-mo-mega]', li)) li.addEventListener('mouseenter', () => { if (ordinateur.matches) { clearTimeout(minuteur); fermerTout(); } });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') fermerTout(); });
    document.addEventListener('click', (e) => { if (!e.target.closest('[data-mo-nav-item]')) fermerTout(); });

    /* Recherche sur téléphone */
    const ouvrirRecherche = $('[data-mo-recherche-ouvrir]', entete);
    ouvrirRecherche?.addEventListener('click', () => {
      const ouvert = entete.classList.toggle('recherche-ouverte');
      ouvrirRecherche.setAttribute('aria-expanded', String(ouvert));
      if (ouvert) setTimeout(() => $('[data-mo-recherche-champ]', entete)?.focus(), 50);
    });
  }

  /* ---------- Recherche en direct ---------- */
  $$('[data-mo-recherche]').forEach((zone) => {
    const champ = $('[data-mo-recherche-champ]', zone);
    const boite = $('[data-mo-suggestions]', zone);
    if (!champ || !boite) return;
    let minuteur, ctrl;
    const fermer = () => { boite.hidden = true; };
    champ.addEventListener('input', () => {
      clearTimeout(minuteur);
      const q = champ.value.trim();
      if (q.length < 2) return fermer();
      minuteur = setTimeout(async () => {
        ctrl?.abort();
        ctrl = new AbortController();
        boite.hidden = false;
        boite.innerHTML = '<div class="mo-suggestions__chargement"></div>';
        try {
          const url = `${racine}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=moida-suggestions`;
          const r = await fetch(url, { signal: ctrl.signal });
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const corps = doc.querySelector('[data-mo-suggestions-corps]');
          boite.innerHTML = corps ? corps.outerHTML : '';
          if (!corps) fermer();
        } catch (e) {
          if (e.name !== 'AbortError') fermer();
        }
      }, 250);
    });
    champ.addEventListener('keydown', (e) => { if (e.key === 'Escape') { fermer(); champ.blur(); } });
    document.addEventListener('click', (e) => { if (!zone.contains(e.target)) fermer(); });
  });

  /* ---------- Fenêtres (tiroir, panier) ---------- */
  const bloquer = (oui) => document.documentElement.classList.toggle('mo-bloque', oui);
  const ouvrirFenetre = (f) => { if (!f) return; f.hidden = false; bloquer(true); setTimeout(() => f.querySelector('button, a')?.focus(), 30); };
  const fermerFenetre = (f) => { if (!f) return; f.hidden = true; if (!$$('.mo-tiroir:not([hidden]), .mo-panier:not([hidden])').length) bloquer(false); };

  /* Tiroir du téléphone */
  const tiroir = $('[data-mo-tiroir]');
  if (tiroir) {
    const montrer = (nom) => {
      $$('[data-mo-panneau]', tiroir).forEach((p) => { p.hidden = p.dataset.moPanneau !== nom; });
      tiroir.classList.toggle('panneau-ouvert', nom !== 'racine');
      $('.mo-tiroir__corps', tiroir).scrollTop = 0;
    };
    $$('[data-mo-ouvrir-tiroir]').forEach((b) => b.addEventListener('click', () => { montrer('racine'); ouvrirFenetre(tiroir); b.setAttribute('aria-expanded', 'true'); }));
    $$('[data-mo-fermer-tiroir]', tiroir).forEach((b) => b.addEventListener('click', () => { fermerFenetre(tiroir); $$('[data-mo-ouvrir-tiroir]').forEach((x) => x.setAttribute('aria-expanded', 'false')); }));
    $$('[data-mo-ouvrir-panneau]', tiroir).forEach((b) => b.addEventListener('click', () => montrer(b.dataset.moOuvrirPanneau)));
    $('[data-mo-tiroir-retour]', tiroir)?.addEventListener('click', () => montrer('racine'));
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.mo-tiroir:not([hidden]), .mo-panier:not([hidden])').forEach(fermerFenetre); });

  /* ---------- Panier (Cart API, sans rechargement) ----------
     Les changements passent un par un (file) ; la boîte du panier reste en place, seul son contenu est remplacé.
     + et − : le chiffre, le prix de la ligne et le sous-total changent tout de suite ; l'envoi part 300 ms après le
     dernier clic, avec la quantité voulue (10 clics = un seul envoi « 10 »). */
  const panier = () => $('[data-mo-panier]');
  const majCompte = (n) => $$('[data-mo-compte-panier]').forEach((el) => { el.textContent = n; });
  const dh = (centimes) => {
    const [e, c] = (Math.max(0, centimes) / 100).toFixed(2).split('.');
    return `${e.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')},${c} DH`;
  };
  let file = Promise.resolve();
  const enFile = (tache) => (file = file.catch(() => {}).then(tache));
  const voulu = new Map(); // clé de ligne → quantité demandée, pas encore confirmée
  const minuteurs = new Map();
  let enCours = 0; // envois prévus ou en route
  let dernier = null; // dernier rendu reçu, posé quand plus rien n'est en route

  const remplacerPanier = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const neuf = doc.querySelector('[data-mo-panier-contenu]');
    const ancien = $('[data-mo-panier-contenu]');
    if (!neuf || !ancien) return;
    const defile = $('.mo-panier__corps', ancien)?.scrollTop || 0;
    const actif = document.activeElement;
    const repere = ancien.contains(actif) && actif.dataset.moQuantiteLigne ? `[data-mo-quantite-ligne="${actif.dataset.moQuantiteLigne}"][data-pas="${actif.dataset.pas}"]` : null;
    ancien.replaceChildren(...neuf.childNodes);
    const corps = $('.mo-panier__corps', ancien);
    if (corps) corps.scrollTop = defile;
    if (repere) $(repere, ancien)?.focus();
    const n = $('[data-mo-panier-nombre]', ancien);
    if (n) majCompte(n.textContent.trim());
  };
  const toast = (texte) => {
    let t = $('.mo-toast');
    if (!t) { t = document.createElement('div'); t.className = 'mo-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = texte;
    t.classList.add('est-visible');
    clearTimeout(t._m);
    t._m = setTimeout(() => t.classList.remove('est-visible'), 2200);
  };
  const appel = async (url, corps) => {
    const r = await fetch(`${racine}${url}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...corps, sections: 'moida-panier', sections_url: window.location.pathname }),
    });
    const d = await r.json();
    if (!r.ok) throw new Error(d.description || d.message || 'Erreur');
    return d;
  };
  const relire = async () => {
    try { remplacerPanier(await (await fetch(`${window.location.pathname}?section_id=moida-panier`)).text()); } catch (e) { /* rien */ }
  };
  const ajouter = (id, quantite = 1, bouton) => {
    bouton?.classList.add('est-occupe');
    return enFile(async () => {
      const p = panier();
      try {
        const d = await appel('cart/add.js', { items: [{ id: Number(id), quantity: Number(quantite) }] });
        if (enCours === 0) remplacerPanier(d.sections && d.sections['moida-panier']);
        else dernier = d.sections && d.sections['moida-panier'];
        bouton?.classList.add('est-ajoute');
        setTimeout(() => bouton?.classList.remove('est-ajoute'), 1400);
        if (!p) toast('Ajouté au panier');
        else if (p.hidden) ouvrirFenetre(p);
      } catch (e) {
        toast(e.message || 'Impossible d’ajouter ce produit');
      } finally {
        bouton?.classList.remove('est-occupe');
      }
    });
  };
  const sousTotal = (p) => {
    const st = $('[data-mo-sous-total]', p);
    if (!st) return;
    let total = 0;
    $$('[data-mo-ligne]', p).forEach((l) => {
      const q = Number($('[data-mo-quantite-valeur]', l)?.textContent || 0);
      total += Number(l.dataset.unite || 0) * q;
    });
    st.textContent = dh(total);
  };
  const envoyer = (cle) => enFile(async () => {
    const q = voulu.get(cle);
    try {
      const d = await appel('cart/change.js', { id: cle, quantity: q });
      majCompte(d.item_count);
      dernier = d.sections && d.sections['moida-panier'];
    } catch (e) {
      toast(e.message || 'Quantité impossible');
      dernier = null;
    } finally {
      if (voulu.get(cle) === q) voulu.delete(cle);
      enCours -= 1;
      if (enCours === 0) { if (dernier) remplacerPanier(dernier); else relire(); dernier = null; }
    }
  });
  const lierPanier = () => {
    const p = panier();
    if (!p || p.dataset.lie) return;
    p.dataset.lie = '1';
    p.addEventListener('click', (e) => {
      if (e.target.closest('[data-mo-fermer-panier]')) { fermerFenetre(p); return; }
      const b = e.target.closest('[data-mo-quantite-ligne]');
      if (!b) return;
      const cle = b.dataset.moQuantiteLigne;
      const ligne = b.closest('[data-mo-ligne]');
      const chiffre = ligne && $('[data-mo-quantite-valeur]', ligne);
      const actuel = voulu.has(cle) ? voulu.get(cle) : Number(chiffre?.textContent || 0);
      const q = b.dataset.pas === '0' ? 0 : Math.max(0, actuel + Number(b.dataset.pas));
      voulu.set(cle, q);
      if (chiffre) chiffre.textContent = q;
      if (ligne) {
        const prix = $('[data-mo-prix-ligne]', ligne);
        if (prix) prix.textContent = dh(Number(ligne.dataset.unite || 0) * q);
        $('s', ligne)?.remove();
        ligne.classList.toggle('est-retiree', q === 0);
      }
      sousTotal(p);
      if (minuteurs.has(cle)) clearTimeout(minuteurs.get(cle));
      else enCours += 1;
      minuteurs.set(cle, setTimeout(() => { minuteurs.delete(cle); envoyer(cle); }, 300));
    });
  };
  lierPanier();
  $$('[data-mo-ouvrir-panier]').forEach((a) => a.addEventListener('click', (e) => {
    const p = panier();
    if (!p) return;
    e.preventDefault();
    ouvrirFenetre(p);
  }));
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mo-ajout]');
    if (!b) return;
    e.preventDefault();
    ajouter(b.dataset.moAjout, 1, b);
  });
  $$('form[data-mo-form-produit]').forEach((f) => f.addEventListener('submit', (e) => {
    e.preventDefault();
    const fd = new FormData(f);
    ajouter(fd.get('id'), fd.get('quantity') || 1, f.querySelector('[type=submit]'));
  }));

  /* ---------- Défileurs (cartes, images, vidéos, articles) ---------- */
  $$('[data-mo-defileur]').forEach((d) => {
    const f = $('[data-mo-fenetre]', d);
    if (!f) return;
    const prec = $('[data-mo-prec]', d);
    const suiv = $('[data-mo-suiv]', d);
    const pas = () => {
      const item = f.firstElementChild && (f.firstElementChild.matches('ul') ? f.firstElementChild.firstElementChild : f.firstElementChild);
      const largeur = item ? item.getBoundingClientRect().width : 200;
      return Math.max(largeur, Math.floor(f.clientWidth / (largeur + 8)) * (largeur + 8));
    };
    const fin = () => f.scrollLeft + f.clientWidth >= f.scrollWidth - 4;
    const debut = () => f.scrollLeft <= 4;
    prec?.addEventListener('click', () => f.scrollBy({ left: debut() ? f.scrollWidth : -pas() }));
    suiv?.addEventListener('click', () => f.scrollBy({ left: fin() ? -f.scrollWidth : pas() }));
    const verifier = () => d.classList.toggle('sans-fleches', f.scrollWidth <= f.clientWidth + 4);
    verifier();
    new ResizeObserver(verifier).observe(f);
  });

  /* ---------- Bannière ---------- */
  $$('[data-mo-banniere]').forEach((b) => {
    const piste = $('[data-mo-piste]', b);
    const n = piste ? piste.children.length : 0;
    if (n < 2) return;
    const points = $$('[data-mo-point]', b);
    let i = 0, minuteur;
    const aller = (k) => {
      i = (k + n) % n;
      piste.style.transform = `translateX(${-100 * i}%)`;
      points.forEach((p, j) => p.classList.toggle('est-actif', j === i));
    };
    const auto = Number(b.dataset.auto) || 0;
    const relancer = () => { clearInterval(minuteur); if (auto && !moinsDanimations.matches) minuteur = setInterval(() => aller(i + 1), auto * 1000); };
    points.forEach((p) => p.addEventListener('click', () => { aller(Number(p.dataset.moPoint)); relancer(); }));
    let x0 = null;
    b.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    b.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { aller(i + (dx < 0 ? 1 : -1)); relancer(); }
      x0 = null;
    });
    b.addEventListener('mouseenter', () => clearInterval(minuteur));
    b.addEventListener('mouseleave', relancer);
    relancer();
  });

  /* ---------- Bande défilante : même vitesse partout (50 px par seconde) ---------- */
  $$('.mo-defilant__piste').forEach((p) => {
    const g = p.firstElementChild;
    if (g) p.style.animationDuration = `${Math.max(10, g.getBoundingClientRect().width / 50)}s`;
  });

  /* ---------- Vidéos Instagram : lecture sans son quand elles sont à l'écran ---------- */
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entrees) => entrees.forEach((en) => {
      const v = en.target;
      if (en.isIntersecting && !moinsDanimations.matches) {
        v.preload = 'auto';
        v.muted = true;
        v.play().then(() => v.closest('.mo-reels__item')?.classList.add('en-lecture')).catch(() => {});
      } else {
        v.pause();
        v.closest('.mo-reels__item')?.classList.remove('en-lecture');
      }
    }), { threshold: 0.6 });
    $$('.mo-reels video').forEach((v) => { v.muted = true; v.playsInline = true; obs.observe(v); });
  }

  /* ---------- Pied de page : menus repliés sur téléphone ---------- */
  const plier = () => $$('[data-mo-accordeon-mobile]').forEach((d) => { d.open = ordinateur.matches; });
  plier();
  ordinateur.addEventListener('change', plier);
  $$('[data-mo-accordeon-mobile] summary').forEach((s) => s.addEventListener('click', (e) => { if (ordinateur.matches) e.preventDefault(); }));

  /* ---------- Fiche produit ---------- */
  $$('[data-mo-produit]').forEach((zone) => {
    const vues = $$('[data-mo-vue]', zone);
    const vignettes = $$('[data-mo-vignette]', zone);
    const piste = $('[data-mo-galerie]', zone);
    const montrer = (k) => {
      if (!vues.length) return;
      const i = (k + vues.length) % vues.length;
      piste?.scrollTo({ left: vues[i].offsetLeft - piste.offsetLeft, behavior: 'smooth' });
      vignettes.forEach((v, j) => v.classList.toggle('est-active', j === i));
      zone.dataset.vue = i;
    };
    vignettes.forEach((v, j) => v.addEventListener('click', () => montrer(j)));
    $('[data-mo-vue-prec]', zone)?.addEventListener('click', () => montrer(Number(zone.dataset.vue || 0) - 1));
    $('[data-mo-vue-suiv]', zone)?.addEventListener('click', () => montrer(Number(zone.dataset.vue || 0) + 1));
    piste?.addEventListener('scroll', () => {
      clearTimeout(piste._m);
      piste._m = setTimeout(() => {
        const i = Math.round(piste.scrollLeft / (piste.clientWidth || 1));
        vignettes.forEach((v, j) => v.classList.toggle('est-active', j === i));
        zone.dataset.vue = i;
      }, 80);
    });

    /* quantité */
    $$('[data-mo-quantite]', zone).forEach((q) => {
      const champ = $('input', q);
      $$('button', q).forEach((b) => b.addEventListener('click', () => {
        const v = Math.max(1, (Number(champ.value) || 1) + Number(b.dataset.pas));
        champ.value = v;
        champ.dispatchEvent(new Event('change', { bubbles: true }));
      }));
    });

    /* description pliée sur téléphone */
    const desc = $('[data-mo-description]', zone);
    if (desc) {
      const texte = $('.mo-texte-riche', desc);
      desc.classList.add('est-plie');
      if (texte && texte.scrollHeight <= texte.clientHeight + 2) desc.classList.remove('est-plie');
      $('[data-mo-lire-suite]', desc)?.addEventListener('click', () => desc.classList.remove('est-plie'));
    }

    /* variantes : prix, bouton, photo, adresse */
    const donnees = $('[data-mo-variantes]', zone);
    if (!donnees) return;
    const variantes = JSON.parse(donnees.textContent);
    const choix = $$('[data-mo-option]', zone);
    const champId = $('input[name="id"]', zone);
    const bouton = $('[data-mo-bouton-ajout]', zone);
    const majVariante = () => {
      const valeurs = choix.map((c) => c.value);
      const v = variantes.find((x) => x.options.every((o, k) => o === valeurs[k]));
      if (!v) return;
      champId.value = v.id;
      const prix = $('[data-mo-prix-variante]', zone);
      if (prix) prix.innerHTML = v.barre ? `<s>${v.barre}</s> <span class="mo-prix__promo">${v.prix}</span>` : `<span>${v.prix}</span>`;
      const pb = $('[data-mo-prix-bouton]', zone);
      if (pb) pb.innerHTML = v.prix;
      if (bouton) {
        bouton.disabled = !v.available;
        $('[data-mo-texte-bouton]', bouton).textContent = v.available ? bouton.dataset.texte : bouton.dataset.epuise;
      }
      const u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
      if (v.media) {
        const k = vues.findIndex((x) => x.dataset.moVue === String(v.media));
        if (k >= 0) montrer(k);
      }
    };
    choix.forEach((c) => c.addEventListener('change', majVariante));
  });

  /* ---------- Recommandations sous la fiche produit ---------- */
  $$('[data-mo-recos]').forEach(async (z) => {
    if (z.children.length || !z.dataset.url) return;
    try {
      const html = await (await fetch(z.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const neuf = doc.querySelector('[data-mo-recos]');
      if (!neuf || !neuf.children.length) return;
      z.innerHTML = neuf.innerHTML;
      const d = $('[data-mo-defileur]', z);
      const f = d && $('[data-mo-fenetre]', d);
      if (!f) return;
      const pas = () => f.clientWidth * 0.8;
      $('[data-mo-prec]', d)?.addEventListener('click', () => f.scrollBy({ left: -pas() }));
      $('[data-mo-suiv]', d)?.addEventListener('click', () => f.scrollBy({ left: pas() }));
    } catch (e) { /* rien */ }
  });

  /* ---------- Collection : filtres et tri ---------- */
  $$('[data-mo-filtres]').forEach((form) => {
    const envoyer = () => {
      const fd = new FormData(form);
      const p = new URLSearchParams();
      for (const [k, v] of fd.entries()) if (v !== '') p.append(k, v);
      window.location.search = p.toString();
    };
    $$('input[type=checkbox], select', form).forEach((c) => c.addEventListener('change', envoyer));
    $$('[data-mo-prix]', form).forEach((zone) => {
      const [mini, maxi] = $$('input[type=number]', zone);
      const [r1, r2] = $$('input[type=range]', zone);
      const barre = $('[data-mo-prix-barre]', zone);
      const max = Number(zone.dataset.max) || 100;
      const dessiner = () => {
        const a = Math.min(Number(r1.value), Number(r2.value));
        const b = Math.max(Number(r1.value), Number(r2.value));
        barre.style.left = `${(a / max) * 100}%`;
        barre.style.right = `${100 - (b / max) * 100}%`;
      };
      const depuisCurseurs = () => { mini.value = Math.min(r1.value, r2.value); maxi.value = Math.max(r1.value, r2.value); dessiner(); };
      const depuisChamps = () => { r1.value = mini.value || 0; r2.value = maxi.value || max; dessiner(); };
      [r1, r2].forEach((r) => { r.addEventListener('input', depuisCurseurs); r.addEventListener('change', envoyer); });
      [mini, maxi].forEach((c) => { c.addEventListener('input', depuisChamps); c.addEventListener('change', envoyer); });
      dessiner();
    });
  });
  $$('[data-mo-tri]').forEach((s) => s.addEventListener('change', () => {
    const u = new URL(window.location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  }));
  $$('[data-mo-ouvrir-filtres]').forEach((b) => b.addEventListener('click', () => {
    const z = document.getElementById(b.getAttribute('aria-controls'));
    if (!z) return;
    const ouvert = z.classList.toggle('est-ouvert');
    b.setAttribute('aria-expanded', String(ouvert));
    bloquer(ouvert);
  }));
  $$('[data-mo-fermer-filtres]').forEach((b) => b.addEventListener('click', () => {
    b.closest('.est-ouvert')?.classList.remove('est-ouvert');
    $$('[data-mo-ouvrir-filtres]').forEach((x) => x.setAttribute('aria-expanded', 'false'));
    bloquer(false);
  }));
})();

/* Mode « exemples » : un produit d'exemple ne s'ajoute pas au panier, on le dit. */
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-mo-exemple-ajout]');
  if (!b) return;
  let t = document.querySelector('.mo-toast');
  if (!t) { t = document.createElement('div'); t.className = 'mo-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
  t.textContent = 'Produit d’exemple : le panier marchera avec les vrais produits';
  t.classList.add('est-visible');
  clearTimeout(t._m);
  t._m = setTimeout(() => t.classList.remove('est-visible'), 2600);
});
